import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBasketball24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconBasketball24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.25 12.75v7.717a8.46 8.46 0 0 1-4.703-1.946 10.7 10.7 0 0 0 2.177-5.771zm1.5 0v7.717a8.46 8.46 0 0 0 4.703-1.946 10.7 10.7 0 0 1-2.177-5.771zm2.526-1.5H12.75V3.533a8.46 8.46 0 0 1 4.703 1.946 10.7 10.7 0 0 0-2.177 5.771m1.504 1.5a9.2 9.2 0 0 0 1.744 4.699 8.46 8.46 0 0 0 1.943-4.699zm3.687-1.5H16.78a9.2 9.2 0 0 1 1.744-4.699 8.46 8.46 0 0 1 1.943 4.699m-9.217 0H8.724a10.7 10.7 0 0 0-2.177-5.77 8.46 8.46 0 0 1 4.703-1.947zm-4.03 0a9.2 9.2 0 0 0-1.744-4.699 8.46 8.46 0 0 0-1.943 4.699zm-3.687 1.5a8.46 8.46 0 0 0 1.943 4.699A9.2 9.2 0 0 0 7.22 12.75zM12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconBasketball24);
